import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import { AiOutlineDownload } from "react-icons/ai";
import { saveAs } from "file-saver";
import { IoDocumentTextOutline } from "react-icons/io5";
import { startCase } from "lodash";
import helpers from "utils/helpers";
import TimeLogs from "components/reusable/TimeLogs";
import useToastContext from 'hooks/useToastContext'

const EmployeeTaskView = ({ handleView, currentItem }) => {
  const { t } = useTranslation();
  const notification = useToastContext()
  const [taskID, setTaskID] = useState({});
  const [viewData, setViewData] = useState(false);
  const [timeLogData, setTimeLogData] = useState([]);
  const [timeLogDataCollaborated, setTimeLogDataCollaborated] = useState([]);
  const [collaborateTimeLogData, setCollaborateTimeLogData] = useState("");

  const downloadFile = async (fileUrl) => {
    try {
      // Extract file extension from URL
      const fileExtension = fileUrl.split('.').pop();
      
      // Fetch the file
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      
      // Save as "document" with original extension
      saveAs(blob, `Document.${fileExtension}`);
    } catch (error) {
      console.error('Error downloading file:', error);
      notification.error('Failed to download file');
    }
  };

  const getTimeLogList = async () => {
    try {
      let payload = {
        taskId: taskID?._id,
      };
      const res = await apiGet(apiPath.getTimeLogList, payload);
      setTimeLogData(res?.data?.results?.employeeLogs);
      setTimeLogDataCollaborated(res?.data?.results?.collabEmployeeLogs);
    } catch (error) {
      console.log("error:", error);
    }
  };

  useEffect(() => {
    getTimeLogList();
  }, [taskID]);

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[96vh] overflow-y-auto	">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                {!viewData ? (
                  <div className="flex justify-between w-full">
                    <h3 className="text-xl font-semibold">{t("VIEW_EMPLOYEE_TASK_ASSIGN")}</h3>
                  </div>
                ) : (
                  <h3 className="text-xl font-semibold">{t("VIEW_TIME_LOGS")} </h3>
                )}

                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => handleView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              {!viewData ? (
                <>
                  <div className="flex pt-3 justify-end">
                    <button
                      className="cursor-pointer bg-success bg-light p-2 px-4 border border-success rounded me-3 bg-gray-200 text-emerald-700 border-1 border-color-500 d-inline-block"
                      onClick={() => {
                        setViewData(true);
                        setCollaborateTimeLogData("timeLogData");
                        setTaskID({
                          _id: currentItem._id,
                        });
                      }}
                    >
                      {t("VIEW_TIME_LOG")}
                    </button>
                    <button className=" bg-success bg-light p-2 px-4 border border-success rounded  me-3 bg-gray-200 text-emerald-700 border-1 border-color-500 disabled" disabled>
                      {t("TOTAL_TIME_SPEND")} : {helpers.calculateTotalTaskTime(currentItem?.timeLogs)}
                    </button>
                    <button className=" bg-success bg-light p-2 px-4 border border-success rounded  me-3 bg-gray-200 text-emerald-700 border-1 border-color-500 disabled" disabled>
                      {t("STATUS")} : {startCase(currentItem?.status)}
                    </button>
                  </div>
                  <div className="relative p-6 flex-auto">
                    <div className="grid grid-cols-3">
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Employee name</strong>
                          <h6>{helpers.orCondition(currentItem.employee?.name, "")}</h6>
                        </div>
                      </div>
                      
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Employee ID</strong>
                          <h6>{helpers.orCondition(currentItem.employee?.employeeId, "")}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Task name</strong>
                          <h6>{startCase(currentItem?.name)}</h6>
                        </div>
                      </div>

                      <div className="py-8 px-7 sm:py-4 sm:px-2 ">
                        <div className="z-0 mb-2 relative w-full group">
                          <strong>Start date/time</strong>
                          <h6>{dayjs(currentItem?.startDateTime).format("MM-DD-YYYY hh:mm A")} </h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>End date/time</strong>
                          <h6>{dayjs(currentItem?.endDateTime).format("MM-DD-YYYY hh:mm A")} </h6>
                        </div>
                      </div>
                      <div className="sm:px-2 py-8 sm:py-4 px-7">
                        <div className="w-full group relative z-0 mb-2 ">
                          <strong>Task description</strong>
                          {/* <h6>{startCase(currentItem.description) || ""}</h6> */}
                          <div className="inner-html break-words" dangerouslySetInnerHTML={{ __html: currentItem.description }} />
                        </div>
                      </div>
                      <div className="sm:py-4 py-8 px-7 sm:px-2 ">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Task state</strong>
                          <h6>{startCase(currentItem?.state) || ""}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Tags</strong>
                          <h6>{startCase(currentItem.tags) || ""}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Total time spender on the task</strong>
                          <h6> {helpers.calculateTotalTaskTime(currentItem?.timeLogs)}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Employee task started date/time</strong>
                          <h6>{helpers.ternaryCondition(currentItem?.timeLogs?.[0]?.startTime, dayjs(currentItem?.timeLogs?.[0]?.startTime).format("MM-DD-YYYY hh:mm A"), "N/A")}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Employee task end date/time</strong>
                          <h6> {helpers.ternaryCondition(currentItem?.taskEndDateTime, dayjs(currentItem?.taskEndDateTime).format("MM-DD-YYYY hh:mm A"), "N/A")}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Task address</strong>
                          <h6>{helpers.orCondition(currentItem.address, "")}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Status</strong>
                          <h6>{startCase(currentItem?.status)}</h6>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1">
                      <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                        <div className="relative z-0 mb-0 w-full group">
                          <strong className="mb-3 block">Assign task document</strong>
                          <div className="grid-cols-5 grid gap-x-4">
                            {helpers.ternaryCondition(
                              currentItem?.documents && currentItem?.documents?.length > 0,
                              currentItem?.documents?.map((val, index) => (
                                <div className="justify-between flex items-center border-2 rounded-lg p-3 ">
                                  <div key={index} className="object-cover item overflow-hidden ">
                                    <span>
                                      <IoDocumentTextOutline className="text-4xl" />
                                    </span>
                                  </div>
                                  <button type="button" title="Download" className="bg-LightBlue text-sm px-2 mr-3 mt-2 ml-3 mb-2 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue" onClick={() => downloadFile(val)}>
                                    <AiOutlineDownload style={{ width: "15px", fontWeight: 800 }} />
                                  </button>
                                </div>
                              )),
                              <img alt="" className="w-16 h-16 rounded-full" src={"./images/no_file_found.png"} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1">
                      <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                        <div className="relative z-0 mb-0 w-full group">
                          <strong className="mb-3 block">Employee task document</strong>
                          <div className="grid grid-cols-5 gap-x-4">
                            {helpers.ternaryCondition(
                              currentItem?.endTaskDocuments && currentItem?.endTaskDocuments?.length > 0,
                              currentItem?.endTaskDocuments?.map((val, index) => (
                                <div className="flex items-center border-2 rounded-lg p-3 justify-between">
                                  <div className="item object-cover overflow-hidden " key={index}>
                                    <span>
                                      <IoDocumentTextOutline className="text-4xl" />
                                    </span>
                                  </div>
                                  <button
                                    title="Download"
                                    onClick={() => downloadFile(val)}
                                    type="button"
                                    className="bg-LightBlue text-sm px-2 mr-3 mt-2 ml-3 mb-2 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue"
                                  >
                                    <AiOutlineDownload
                                      style={{
                                        width: "15px",
                                        fontWeight: 800,
                                      }}
                                    />
                                  </button>
                                </div>
                              )),
                              <img src={"./images/no_file_found.png"} alt="" className="w-16 h-16 rounded-full" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {helpers.ternaryCondition(
                    currentItem?.collaborationStatus === "accepted",
                    <>
                      <hr className="my-3" />
                      <div className="flex pt-3 justify-end">
                        <button
                          className="cursor-pointer bg-success bg-light p-2 px-4 border border-success rounded me-3 bg-gray-200 text-emerald-700 border-1 border-color-500 d-inline-block"
                          onClick={() => {
                            setViewData(true);
                            setCollaborateTimeLogData("timeLogDataCollaborate");
                            setTaskID({
                              _id: currentItem._id,
                            });
                          }}
                        >
                          {t("VIEW_TIME_LOG")}
                        </button>
                        <button className=" bg-success bg-light p-2 px-4 border border-success rounded  me-3 bg-gray-200 text-emerald-700 border-1 border-color-500 disabled" disabled>
                          {t("TOTAL_TIME_SPEND")} : {helpers.calculateTotalTaskTime(currentItem?.collaborationTimeLogs)}
                        </button>
                        <button className=" bg-success bg-light p-2 px-4 border border-success rounded  me-3 bg-gray-200 text-emerald-700 border-1 border-color-500 disabled" disabled>
                          {t("STATUS")} : {startCase(currentItem?.collaborationStatus)}
                        </button>
                      </div>
                      <div className="relative p-6 flex-auto">
                        <div className="grid grid-cols-3">
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Employee name</strong>
                              <h6>{helpers.orCondition(currentItem.collaboratedEmployee?.name, "")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Employee ID</strong>
                              <h6>{helpers.orCondition(currentItem.collaboratedEmployee?.employeeId, "")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Task name</strong>
                              <h6>{startCase(currentItem?.name)}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Task description</strong>
                              <h6>{helpers.orCondition(currentItem.description, "N/A")}</h6>
                            </div>
                          </div>
                          <div className="py-8 sm:py-4 sm:px-2 px-7">
                            <div className="mb-2 relative z-0 w-full group">
                              <strong>Start date/time</strong>
                              <h6>{dayjs(currentItem?.startDateTime).format("MM-DD-YYYY hh:mm A")} </h6>
                            </div>
                          </div>
                          <div className="px-7 sm:py-4 sm:px-2 py-8 ">
                            <div className="w-full relative z-0 mb-2 group">
                              <strong>End date/time</strong>
                              <h6>{dayjs(currentItem?.endDateTime).format("MM-DD-YYYY hh:mm A")} </h6>
                            </div>
                          </div>
                          <div className="sm:px-2 sm:py-4 py-8 px-7">
                            <div className="z-0 relative mb-2 w-full group">
                              <strong>Task state</strong>
                              <h6>{helpers.orCondition(startCase(currentItem?.collaborationState), "N/A")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Tags</strong>
                              <h6>{helpers.orCondition(startCase(currentItem?.tags), "N/A")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Total time spender on the task</strong>
                              <h6> {helpers.calculateTotalTaskTime(currentItem?.collaborationTimeLogs)}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Employee task started date/time</strong>
                              <h6>{helpers.ternaryCondition(currentItem?.collaborationTimeLogs?.[0]?.startTime, dayjs(currentItem?.collaborationTimeLogs?.[0]?.startTime).format("MM-DD-YYYY hh:mm A"), "N/A")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Employee task end date/time</strong>
                              <h6> {helpers.ternaryCondition(currentItem?.taskEndDateTimeCollaboration, dayjs(currentItem?.taskEndDateTimeCollaboration).format("MM-DD-YYYY hh:mm A"), "N/A")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Task address</strong>
                              <h6>{helpers.orCondition(currentItem.address, "")}</h6>
                            </div>
                          </div>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 mb-2 w-full group">
                              <strong>Status</strong>
                              <h6>{startCase(currentItem?.collaborationStatus)}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-1">
                          <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                            <div className="relative z-0 mb-0 w-full group">
                              <strong className="mb-3 block">Assign task document</strong>
                              <div className="grid-cols-5 grid gap-x-4">
                                {helpers.ternaryCondition(
                                  currentItem?.documents && currentItem?.documents?.length > 0,
                                  currentItem?.documents?.map((val, index) => (
                                    <div className="border-2 flex items-center rounded-lg p-3 justify-between">
                                      <div key={index} className="overflow-hidden item object-cover ">
                                        <span>
                                          <IoDocumentTextOutline className="text-4xl" />
                                        </span>
                                      </div>
                                      <button
                                        type="button"
                                        className="mb-2 py-2 bg-LightBlue text-sm px-2 mr-3 mt-2 ml-3 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue"
                                        title="Download"
                                        onClick={() => downloadFile(val)}
                                      >
                                        <AiOutlineDownload
                                          style={{
                                            fontWeight: 800,
                                            width: "15px",
                                          }}
                                        />
                                      </button>
                                    </div>
                                  )),
                                  <img src={"./images/no_file_found.png"} alt="" className="w-16 h-16 rounded-full" />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-1">
                          <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                            <div className="relative z-0 mb-0 w-full group">
                              <strong className="mb-3 block">employee task document</strong>
                              <div className="grid grid-cols-5 gap-x-4">
                                {helpers.ternaryCondition(
                                  currentItem?.endTaskCollaborationDocuments && currentItem?.endTaskCollaborationDocuments?.length > 0,
                                  currentItem?.endTaskCollaborationDocuments?.map((val, index) => (
                                    <div className="flex items-center border-2 rounded-lg p-3 justify-between">
                                      <div className="item object-cover overflow-hidden " key={index}>
                                        <span>
                                          <IoDocumentTextOutline className="text-4xl" />
                                        </span>
                                      </div>
                                      <button
                                        title="Download"
                                        onClick={() => downloadFile(val)}
                                        type="button"
                                        className="bg-LightBlue text-sm px-2 mr-3 mt-2 ml-3 mb-2 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue"
                                      >
                                        <AiOutlineDownload
                                          style={{
                                            width: "15px",
                                            fontWeight: 800,
                                          }}
                                        />
                                      </button>
                                    </div>
                                  )),
                                  <img src={"./images/no_file_found.png"} alt="" className="w-16 h-16 rounded-full" />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>,
                    ""
                  )}
                </>
              ) : (
                <div className="p-3">
                  <div className="overflow-x-auto relative rounded-lg border">
                    <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                      <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="py-3 px-6">
                            S.no.
                          </th>
                          <th scope="col" className="py-3 px-6">
                            {t("DATE")}
                          </th>
                          <th scope="col" className="py-3 px-6">
                            {t("START_TIME")}
                          </th>
                          <th scope="col" className="py-3 px-6">
                            {t("END_TIME")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {collaborateTimeLogData === "timeLogData" && <TimeLogs timeLogData={timeLogData} />}

                        {collaborateTimeLogData === "timeLogDataCollaborate" && <TimeLogs timeLogData={timeLogDataCollaborated} />}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {!viewData ? (
                ""
              ) : (
                <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                  <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setViewData(false)}>
                    {t("O_BACK")}
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default EmployeeTaskView;
